module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e150717"
    }
  }, [_vm._v("Things to Remember ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e151217"
    }
  }, [_vm._v("A friend loves at all times, and a brother is born for adversity.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e152017"
    }
  }, [_vm._v("PROVERBS 17:17 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e153417"
    }
  }, [_vm._v("Greater love has no one than this, than to lay down one’s life for his friends.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e154217"
    }
  }, [_vm._v("JOHN 15:13 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e155617"
    }
  }, [_c('b', [_vm._v("It is mutual respect which makes friendship lasting. ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e156417"
    }
  }, [_c('b', [_vm._v("—JOHN HENRY NEWMAN ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e158517"
    }
  }, [_vm._v("A man who has friends must himself be friendly, but there is a friend who sticks closer than a brother.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e159317"
    }
  }, [_vm._v("PROVERBS 18:24 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e160717"
    }
  }, [_c('b', [_vm._v("God evidently does not intend us all to be rich or powerful or great, but He does intend us all to be friends.")])]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e162817"
    }
  }, [_c('b', [_vm._v("—RALPH WALDO EMERSON ")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e164717"
    }
  }, [_vm._v("Wounds from a friend can be trusted, but an enemy multiplies kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e165517"
    }
  }, [_vm._v("PROVERBS 27:6 NIV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e166917"
    }
  }, [_vm._v("No longer do I call you servants, for a servant does not know what his master is doing; but I have called you friends, for all things that I heard from My Father I have made known to you.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e168717"
    }
  }, [_vm._v("JOHN 15:15 NKJV ")]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e170117"
    }
  }, [_vm._v("Encourage each other every day while it is “today.” Help each other so none of you will become hardened because sin has tricked you.")]), _vm._v(" "), _c('p', {
    staticClass: "ext1",
    attrs: {
      "id": "d7e171517"
    }
  }, [_vm._v("HEBREWS 3:13 NCV ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ba3ae00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c13_r1.vue
// module id = 87
// module chunks = 0